import { render, staticRenderFns } from "./billHistory.vue?vue&type=template&id=6a1b3f4c&scoped=true&"
import script from "./billHistory.vue?vue&type=script&lang=js&"
export * from "./billHistory.vue?vue&type=script&lang=js&"
import style0 from "./billHistory.vue?vue&type=style&index=0&id=6a1b3f4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1b3f4c",
  null
  
)

export default component.exports